export const usePercentagesFromArray = () => {
  const getPercentagesFromArray = (data: number[]) => {
    const total = data.reduce((sum, value) => sum + value, 0);
    const percentages = data.map((value) => parseFloat(((value / total) * 100).toFixed(1)));

    return percentages;
  };

  return getPercentagesFromArray;
};

export const usePercentagesFromArrayWithTotal = (data: number[], total: number): number[] => {
  const percentages = data.map((value) => parseFloat(((value / total) * 100).toFixed(1)));

  return percentages;
};
